import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#191970', // A
          'primary-darken1': '#2f589c', // R
          'primary-lighten1': '#8eb5f5', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#ccb800', // B
          'secondary-darken1': '#db8f02', // D
          secondaryBtnText: '#FFFFFF', // B'
          headerBack: '#FFFFFF', // E
          headerText: '#132F57', // F
          logoutBtnText: '#132F57', // G
          topSchoolNamePc: '#191970', // H
          topSecondaryBtn: '#ccb800', // I
          topSecondaryBtnText: '#FFFFFF', // J
          topPrimaryBtn: '#191970', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#191970', // N
          secondaryOutLineBtnText: '#ccb800', // O
          topBtnUpTextSp: '#191970', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#132F57',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#132F57',
          accent: '#191970', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
